<template>
  <div
    ref="domRefRoot"
    class="global-textarea"
    contenteditable
    style="white-space: pre-wrap"
    v-html="_initialMessage.replace(placeholderRegex, match => `<span style=&quot;background: rgba(200, 200, 0, 0.5)&quot;>${match}</span>`)"
    @click="removeClickedPlaceholder"
    @blur="$event => emit('update:initialMessage', ($event.target as HTMLElement).innerText)"
  ></div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";

const props = withDefaults(
  defineProps<{
    initialMessage: string;
  }>(),
  {
    initialMessage: "",
  }
);

const emit = defineEmits<{
  (e: "update:initialMessage", value: string): void;
  (e: "update:placeholderCount", count: number): void;
}>();

// DOM refs ===================================================================
const domRefRoot = ref<HTMLElement | null>(null);

// Copy the iniMessage to a local var =========================================
let _initialMessage = ref<string>("");
// REGEX matches if square brackets contain only uppercase letters, spaces, or slashes
const placeholderRegex = /\[[A-Z\s/-]+]/gim;
const placeholderCount = ref<number>(0);

onMounted(() => {
  _initialMessage.value = props.initialMessage;
  updatePlaceholderCount();
});

watch(
  () => props.initialMessage,
  () => {
    _initialMessage.value = props.initialMessage;
    updatePlaceholderCount();
  }
);

// Modify removeClickedPlaceholder to update the placeholder count
async function removeClickedPlaceholder(event) {
  const isClickedOnTextarea = event.target === domRefRoot.value;

  if (isClickedOnTextarea) {
    return;
  }

  const previousTextNode = event.target.previousSibling;
  event.target.remove();
  putCursorBack(domRefRoot.value, previousTextNode, previousTextNode.data.length);
  // Ensure placeholder count is updated after removal
  // Note: This doesn't watch every text change, but it's good enough for now.  Add a watch if we need this.
  updatePlaceholderCount();
}

function putCursorBack(parentNode, targetTextNode, position) {
  parentNode.focus();
  const range = document.createRange();
  range.setStart(targetTextNode, position);
  range.setEnd(targetTextNode, position);
  const sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
}

// Placeholder count ===================================================================
function updatePlaceholderCount() {
  const currentText = domRefRoot.value?.innerText ? domRefRoot.value?.innerText : _initialMessage.value;
  // console.log("currentText=" + currentText);
  placeholderCount.value = (currentText?.match(placeholderRegex) || []).length;
  // console.log("placeholderCount=" + placeholderCount.value);
  emit("update:placeholderCount", placeholderCount.value);
}
</script>

<style scoped lang="scss"></style>
